/**
 * @ngdoc constant
 * @name AUTH_EVENTS
 * @description
 * The authorization events.
 *
 * @memberof account
 * @type {Object}
 * @property {String} customerSelected  When the user selects a customer from the selection screen.
 * @property {String} customerChanged   When the customer information changes.
 * @property {String} loginFailed       When a user login fails.
 * @property {String} loginSuccess      When the user successfully logs in.
 * @property {String} logoutSuccess     When the user successfully logs out.
 */
const authEvents = {
  customerSelected: 'auth:customer-selected',
  customerChanged: 'auth:customer-changed',
  loginFailed: 'auth:login-failed',
  loginSuccess: 'auth:login-success',
  logoutSuccess: 'auth:logout-success',
};

export default authEvents;



// WEBPACK FOOTER //
// ./src/frontend/modules/account/constants/authEvents.constants.js